function resettableDirective() {
    'ngInject';

    return {
        restrict: 'A',
        require: ['ngModel', '^bbFormResettable'],
        link(scope, element, attrs, ctrls) {
            const ngModelCtrl = ctrls[0];
            const formResettableCtrl = ctrls[1];
            formResettableCtrl.registerInput(attrs.ngModel, ngModelCtrl);
        }
    };
}

// Registers inputs with the bbFormResettable controller allowing them to be cleared
angular
    .module('BB')
    .directive('bbResettable', resettableDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/resettable/resettable.directive.js